import { CheckCheck, User } from 'lucide-react';

import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar';
import { MEDIA_URL } from '@/config';
import useConversationStore from '@/stores/Conversation';

import { Conversation } from '../types';

export const ConversationPreview = ({
  conversation,
}: {
  conversation: Conversation;
}) => {
  const { setSelectedConversation } = useConversationStore();
  return (
    <button
      className="border-stroke flex w-full cursor-pointer items-center gap-x-3 border-b bg-card px-5 py-4 text-left hover:bg-muted/50"
      onClick={() => setSelectedConversation(conversation)}
    >
      <Avatar className="h-8 w-8">
        <AvatarImage
          src={`${
            conversation.conversationUser.profile_photo.includes('https')
              ? conversation.conversationUser.profile_photo
              : `${MEDIA_URL}/${conversation.conversationUser.profile_photo}`
          }`}
        />
        <AvatarFallback className="bg-secondary">
          <User width={12} />
        </AvatarFallback>
      </Avatar>
      <div className="grow truncate">
        <div className="flex items-center justify-between gap-x-1">
          <p
            className={`text-sm ${
              conversation.latestMessage.isUnRead ? 'font-bold' : 'font-normal'
            }`}
          >
            {conversation.conversationUser.username}
          </p>
          <div>
            <span className="flex items-center gap-x-1 text-xs uppercase text-muted-foreground">
              {conversation.latestMessage.isSentByUserRead && (
                <span className="text-primary" title="Read">
                  <CheckCheck size="16" />
                </span>
              )}
              {conversation.latestMessage.date}
            </span>
          </div>
        </div>
        <div className="me-5 truncate">
          <p
            className={`truncate text-xs ${
              conversation.latestMessage.isUnRead
                ? 'font-medium text-white'
                : 'text-muted-foreground'
            }`}
          >
            {conversation.latestMessage.isSentByUser && 'You: '}
            {conversation.latestMessage.message}
          </p>
        </div>
      </div>
    </button>
  );
};
